import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { MdLocalGasStation } from "react-icons/md";
import { HiOutlineRectangleGroup } from "react-icons/hi2";
import { FaCar } from "react-icons/fa";
import { useSelected } from "../contexts/SelectedContext";
import { Filters } from "../components/Filters";
import { ToastComponent } from "../Pages/Components/ToastComponent";
import FuelForm from "./FuelForm";
import FuelGrid from "./FuelGrid";
import { useFuelData } from "./useFuelData";
import { useToast } from "./useToast";

const Fuels = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "title", value: "Abastecimentos" });
  }, [dispatch]);

  const { toastParams, showToast, closeToast } = useToast();

  const { selectedValues } = useSelected();
  const selectedGroup   = selectedValues.veiculos?.[0]       || 0;
  const selectedVehicle = selectedValues.veiculosGroups?.[0] || 0;

  const {
    vehicleGroups,
    vehicles,
    fuelTypes,
    refuelings,
    setSelectedGroupId,
    setSelectedVehicleId,
    isLoadingVehicles,
    isLoadingRefuelings,
    isSaving,
    isDeleting,
    saveRefueling,
    deleteRefueling,
  } = useFuelData();

  useEffect(() => {
    setSelectedGroupId(
      selectedGroup && selectedGroup !== "TODOS" ? selectedGroup : 0
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroup]);

  useEffect(() => {
    setSelectedVehicleId(
      selectedVehicle && selectedVehicle !== "TODOS" ? selectedVehicle : null
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVehicle]);

  const handleSave = async (payload) => {
    try {
      const result = await saveRefueling(payload);
      if (result !== null) {
        showToast("Success", "Sucesso", "Abastecimento registrado com sucesso.");
        return result;
      }
      showToast("Danger", "Erro", "Não foi possível registrar o abastecimento.");
      return null;
    } catch (err) {
      showToast("Danger", "Erro", err?.response?.data?.message || "Erro inesperado.");
      return null;
    }
  };

  const handleDelete = async (payload) => {
    try {
      const result = await deleteRefueling(payload);
      if (result !== null) {
        showToast("Success", "Sucesso", "Registro excluído com sucesso.");
      } else {
        showToast("Danger", "Erro", "Não foi possível excluir o registro.");
      }
    } catch (err) {
      showToast("Danger", "Erro", err?.response?.data?.message || "Erro ao excluir.");
    }
  };

  const hasVehicle =
    selectedVehicle &&
    selectedVehicle !== "TODOS" &&
    selectedVehicle !== 0;

  const vehicleLabel = (() => {
    if (!hasVehicle) return null;
    const v = vehicles.find(
      (v) => String(v.vehicleId ?? v.id) === String(selectedVehicle)
    );
    return v ? (v.plate ?? v.licensePlate ?? v.name) : null;
  })();

  return (
    <div className="ml-4">
      <ToastComponent params={toastParams} closeToast={closeToast} />

      <p className="text3-regular" style={{ color: "var(--text-secondary)" }}>
        Selecione o grupo e o veículo para visualizar e registrar abastecimentos.
      </p>

      {/* ── Filtros ── */}
      <div className="filter-maintenance mb-4">
        <Filters
          id={"veiculos"}
          isMulti={false}
          title={"Grupos"}
          hasSubTitle={true}
          subTitle={"Todos os grupos"}
          options={vehicleGroups}
          icon={HiOutlineRectangleGroup}
          hasIcon={true}
          pageTitle={"maintenances_scheduling"}
        />
        <Filters
          id={"veiculosGroups"}
          isMulti={false}
          title={"Veículos"}
          hasSubTitle={true}
          subTitle={"Selecione o veículo"}
          options={vehicles}
          icon={FaCar}
          hasIcon={true}
          pageTitle={"maintenances_scheduling"}
          isLoading={isLoadingVehicles}
        />
      </div>

      {/* ── Formulário de registro ── */}
      <FuelForm
        fuelTypes={fuelTypes}
        vehicleId={hasVehicle ? selectedVehicle : null}
        isSaving={isSaving}
        onSave={handleSave}
      />

      {/* ── Grid de abastecimentos ── */}
      {hasVehicle && (
        <div className="grid-section mt-2">
          <div className="d-flex align-items-center gap-2 mb-2">
            <MdLocalGasStation
              size={16}
              style={{ color: "var(--color-font-filter-primary)" }}
            />
            <span className="text3-medium" style={{ color: "var(--text-primary)" }}>
              Abastecimentos{vehicleLabel ? ` — ${vehicleLabel}` : ""}
            </span>
          </div>
          <FuelGrid
            refuelings={refuelings}
            isLoading={isLoadingRefuelings}
            isDeleting={isDeleting}
            onDelete={handleDelete}
          />
        </div>
      )}
    </div>
  );
};

export default Fuels;
